export default __webpack_public_path__ + "static/media/redux.a4c9b695.png";